import { Datagrid, NumberField, ReferenceManyField, SimpleList, TextField } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { formatListDate } from "@/utils/date-format";

export const ProjectShowPaymentsTab = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <ReferenceManyField reference="projectPayments" target="projectId" label={false}>
      {isSmall ? (
        <SimpleList
          primaryText={(r) => `₹${Number(r.amount ?? 0).toLocaleString("en-IN")}`}
          secondaryText={(r) => (r.paidDate ? formatListDate(String(r.paidDate)) : "—")}
          tertiaryText={(r) => String(r.payeeName ?? r.purpose ?? "—")}
          linkType="edit"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="edit" sx={{ minWidth: 640 }}>
            <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
            <DisplayDateField source="paidDate" />
            <TextField source="payeeName" emptyText="—" />
            <TextField source="purpose" emptyText="—" />
            <TextField source="paymentMode" />
          </Datagrid>
        </Box>
      )}
    </ReferenceManyField>
  );
};
